export default __webpack_public_path__ + "static/media/full3.80297bb6.jpg";